<template>
  <div>
    <ul v-for="(documentNames, clientId) in documents" :key="clientId">
      <li class="client">
        <p>
          Идентификатор клиента: <span>{{ clientId }}</span>
        </p>
        <p>Документы:</p>
        <ul v-for="(documentPath, i) in documentNames" :key="i">
          <li class="document">
            <a
              :href="fileUri + '/' + documentPath"
              target="_blank"
              rel="noopener noreferrer"
              >{{
                documentPath
                  .replace('upload/files/uprid/documents/', '')
                  .replace(clientId + '/', '')
              }}</a
            >
          </li>
        </ul>
      </li>
      <hr />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Documents',
  data() {
    return {
      fileUri: window.location.protocol + '//' + window.location.hostname
    }
  },
  props: {
    documents: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.client {
  margin: 1rem 0;
}
.client p {
  margin-bottom: 0.5rem;
}
.client span {
  font-weight: bold;
}
.document {
  margin-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// Documents.vue?1459397a